import { Component, OnInit } from '@angular/core';
import { routeService } from 'src/app/route-service.service';
import { LeaderBoardService } from '../leaderBoardService.service';
import { Player } from '../player.model';

@Component({
  selector: 'app-leader-board-list',
  templateUrl: './leader-board-list.component.html',
  styleUrls: ['./leader-board-list.component.scss']
})
export class LeaderBoardListComponent implements OnInit {

  players: Player[];
  game;
  constructor(public routeService: routeService, private leaderBoardService: LeaderBoardService) { }

  ngOnInit(): void {
    const boardIndex = this.leaderBoardService.boardIndex;
    this.players = this.leaderBoardService.board[boardIndex].topPlayers.sort((a, b) => {
      return b.score - a.score;
    });
    this.game = {
      name: this.leaderBoardService.board[boardIndex].game,
      kind: this.leaderBoardService.board[boardIndex].kind
    };    
    // document.body.style.backgroundImage = this.game.kind == 'trivia' ? "url('../../assets/images/backgrounds/night-background.png')" : "url('../../assets/images/backgrounds/bridge.svg'), url('../../assets/images/backgrounds/background.svg')";
  }
}
